import React from 'react'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import useBackButton from 'app/SearchPage/hooks/useBackButton'
import useSearchQuery from 'app/SearchPage/hooks/useSearchQuery'

export const Header = () => {
  const { onClickBack } = useBackButton()
  const { hasSearchQueryFromURL } = useSearchQuery()

  const headerTitle = React.useMemo(
    () => (hasSearchQueryFromURL ? 'Hasil pencarian' : 'Pencarian'),
    [hasSearchQueryFromURL]
  )

  return (
    <HeaderBar borderless className="h-12" fixed>
      <HeaderBarLeftAction
        icon={<Icon>arrow_back</Icon>}
        onClick={onClickBack}
      />
      <HeaderBarTitle>{headerTitle}</HeaderBarTitle>
    </HeaderBar>
  )
}
